var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 87,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "188.882%",
    x2: "-79.241%",
    y2: "-105.181%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "184.421%",
    y1: "41.541%",
    x2: "-83.393%",
    y2: "81.831%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "184.421%",
    y1: "33.023%",
    x2: "-83.393%",
    y2: "113.883%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.738%",
    y1: "193.129%",
    x2: "-70.811%",
    y2: "-109.926%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "128.121%",
    x2: "-79.241%",
    y2: "-37.289%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "87.932%",
    y1: "145.678%",
    x2: "-30.814%",
    y2: "-49.057%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.36 25.588h11.874V13.891H13.36v11.697zm14.843-11.697c0-1.609-1.336-2.925-2.969-2.925H13.36c-1.632 0-2.968 1.316-2.968 2.925v11.697c0 1.609 1.336 2.925 2.968 2.925h11.875c1.633 0 2.97-1.316 2.97-2.925V13.891zM13.36 48.252h11.874V36.555H13.36v11.697zM25.233 33.63H13.36c-1.632 0-2.968 1.316-2.968 2.925v11.697c0 1.609 1.336 2.924 2.968 2.924h11.875c1.633 0 2.97-1.315 2.97-2.924V36.555c0-1.609-1.337-2.925-2.97-2.925z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.887 17.546H35.105c-.816 0-2.226.943-2.226 2.096s1.41 2.096 2.226 2.096h20.782c.816 0 2.226-.943 2.226-2.096s-1.41-2.096-2.226-2.096",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.105 40.16c-.816 0-2.226.944-2.226 2.097s1.41 2.096 2.226 2.096h13.36c.816 0 2.152-.943 2.226-2.096 0-1.153-1.41-2.096-2.226-2.096h-13.36z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.113 30.787c0-1.153-1.41-2.096-2.226-2.096H35.105c-.816 0-2.226.943-2.226 2.096s1.41 2.096 2.226 2.096h20.782c.816 0 2.152-.943 2.226-2.096",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29 38.821v16.742H69.022V32.168H91.29v6.653zm2.226-10.308h-26.72c-.816 0-1.484.658-1.484 1.462v27.781c0 .805.668 1.462 1.485 1.462h26.719c.816 0 1.484-.657 1.484-1.462V29.974c0-.803-.668-1.461-1.484-1.461z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.297 50.007a1.45 1.45 0 0 0 2.078 0l10.39-10.236c.594-.584.594-1.462 0-2.047-.519-.585-1.484-.585-2.078 0l-9.351 9.212-3.414-3.363a1.45 1.45 0 0 0-2.078 0c-.594.585-.594 1.462 0 2.047l4.453 4.387z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.714 81.368v-8.866h9l-9 8.866zm11.352-13.072H56.224v.11h-.127v14.939H3.785V25.954L3.711 3.655h68.281v21.202h3.711V2.924C75.703 1.316 74.367 0 72.734 0H2.97C1.336 0 0 1.316 0 2.924v81.152C0 85.684 1.336 87 2.97 87h58.187c.297-.073.594-.22.817-.439l13.36-13.16c.296-.292.444-.657.444-1.023v-9.504h-3.71v5.422z",
    fill: "url(#f)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.83f2d4ebee11acf276e829bf71941c63.svg";
export { ForwardRef as ReactComponent };